import React from "react";
import { RouteObject } from "react-router-dom";
import { DashboardLayout } from "./components/DashboardLayout/DashboardLayout";
import { SuperAdminDashboard } from "./pages/SuperAdminDashboard";
import { BusinessManagement } from "./pages/BusinessManagement";
import { BusinessDetails } from "./pages/BusinessDetails";
import { Analytics } from "./pages/Analytics";
import { Settings } from "./pages/Settings";
import { SuperAdminGuard } from "./components/SuperAdminGuard";
import { SuperAdminProviderWithChildren } from "./providers/SuperAdminProvider";
import { AuthProvider } from "../auth/AuthProvider";

// Wrap the entire authenticated section with AuthProvider
const AuthenticatedLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <AuthProvider>{children}</AuthProvider>;
};

export const superAdminRoutes: RouteObject[] = [
  {
    path: "super",
    element: (
      <AuthenticatedLayout>
        <SuperAdminGuard>
          <SuperAdminProviderWithChildren>
            <DashboardLayout />
          </SuperAdminProviderWithChildren>
        </SuperAdminGuard>
      </AuthenticatedLayout>
    ),
    children: [
      {
        index: true,
        element: <SuperAdminDashboard />,
      },
      {
        path: "businesses",
        element: <BusinessManagement />,
      },
      {
        path: "businesses/:businessId",
        element: <BusinessDetails />,
      },
      {
        path: "analytics",
        element: <Analytics />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
    ],
  },
];
